import React from 'react';

/**
 * Badge visuel pour indiquer le type de contenu
 * V1: All labels in English (no medical/therapeutic terminology)
 * @param {string} type - Type de contenu: "soundscape" | "relaxation" | "breathing"
 */
const ContentBadge = ({ type }) => {
  // Configuration des couleurs et textes selon le type
  // V1: English labels only, no "therapy" terminology
  const config = {
    therapeutic: {
      // Legacy support - maps to soundscape
      text: 'Soundscape',
      bgColor: 'bg-purple-500/20',
      borderColor: 'border-purple-500/40',
      textColor: 'text-purple-300',
      icon: '🎵'
    },
    soundscape: {
      text: 'Soundscape',
      bgColor: 'bg-purple-500/20',
      borderColor: 'border-purple-500/40',
      textColor: 'text-purple-300',
      icon: '🎵'
    },
    relaxation: {
      text: 'Relaxation',
      bgColor: 'bg-blue-500/20',
      borderColor: 'border-blue-500/40',
      textColor: 'text-blue-300',
      icon: '😌'
    },
    breathing: {
      text: 'Breathing',
      bgColor: 'bg-orange-500/20',
      borderColor: 'border-orange-500/40',
      textColor: 'text-orange-300',
      icon: '🫁'
    },
    radio: {
      text: 'Radio',
      bgColor: 'bg-indigo-500/20',
      borderColor: 'border-indigo-500/40',
      textColor: 'text-indigo-300',
      icon: '📻'
    }
  };

  const badge = config[type] || config.soundscape;

  return (
    <div 
      className={`
        inline-flex items-center justify-center gap-1 px-2.5 py-1
        ${badge.bgColor} ${badge.borderColor} ${badge.textColor}
        backdrop-blur-sm border rounded-full
        text-xs font-medium whitespace-nowrap
      `}
    >
      <span className="text-xs leading-none">{badge.icon}</span>
      <span className="leading-none">{badge.text}</span>
    </div>
  );
};

export default ContentBadge;
